export default "__VITE_ASSET__4MgV_H1B__"